// Configuração da API do Pipedrive
export const PIPEDRIVE_CONFIG = {
  API_KEY: '1e93643b26bf63496cb21d2b22150a153fdcb888', // Substitua pela sua chave do Pipedrive
  BASE_URL: 'https://api.pipedrive.com/v1'
};

// Instruções para configurar a API Key:
// 1. Substitua 'SUA_CHAVE_API_AQUI' pela sua chave real do Pipedrive
// 2. Salve o arquivo
// 3. Reinicie o servidor de desenvolvimento
